import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const isRenewal    = searchParams.get("renewal_success") === "true";
    const isSignup     = searchParams.get("signup_success") === "true";

    // Invalid URL — neither renewal nor signup
    if (!isRenewal && !isSignup) {
        return (
            <div className="min-h-screen bg-black flex items-center justify-center text-white">
                <p>Invalid session.</p>
            </div>
        );
    }

    // RENEWAL SUCCESS
    if (isRenewal) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
                <Card className="max-w-md w-full bg-white border-green-500 shadow-xl">
                    <CardHeader className="text-center">
                        <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto mb-4" />
                        <CardTitle className="text-gray-900 text-2xl">Payment Successful!</CardTitle>
                        <CardDescription className="text-gray-600">
                            Your subscription has been successfully renewed.
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <Button
                            onClick={() => navigate("/dashboard")}
                            className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3"
                        >
                            Continue to Dashboard
                        </Button>
                    </CardContent>
                </Card>
            </div>
        );
    }

    // NEW SIGNUP SUCCESS
    return (
        <div className="min-h-screen bg-black flex items-center justify-center p-4">
            <Card className="max-w-md w-full bg-gray-900 border-orange-500/50">
                <CardHeader className="text-center">
                    <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto mb-4" />
                    <CardTitle className="text-white text-2xl">Payment Received!</CardTitle>
                    <CardDescription className="text-gray-400 mt-2">
                        Your account is being set up. This takes just a moment.
                        <br />
                        <span className="text-gray-500 text-sm">Log in with the email and password you created.</span>
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    <Button
                        onClick={() => navigate("/login")}
                        className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3"
                    >
                        Go to Login
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
}
